import React from 'react';
import styled from 'styled-components';

import { PhotoTitleSection } from '@sayido/ui';

import Section from '../components/Section';
import CreateAccountButton from '../components/CreateAccountButton';

import Img1 from '../images/shared/excited-woman.jpg';

const LinksWrapper = styled.div`
  border-top: solid 4px #f1f1f1;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-columns: 5fr 3fr 3fr;
  font-size: 13px;
  grid-gap: 10px;

  width: 90%;
  margin: 0 auto;
  padding: 40px 0 20px;
  max-width: 1200px;

  .copyright {
    margin-bottom: 24px;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 650px) {
    grid-template-columns: 100%;
  }

  h4 {
    margin: 0 0 12px;
    color: #666;
    @media (max-width: 600px) {
      margin-top: 12px;
    }
  }

  ul {
    padding: 0;
    margin: 0 0 25px;

    @media (max-width: 650px) {
      display: grid;
      grid-gap: 0 10px;
      grid-template-columns: 1fr 1fr;
    }
  }
  li {
    list-style: none;
    padding: 0;
    margin: 0 0 6px;
  }
  a {
    color: #777;
  }
`;

const Footer = ({
  label = 'Try for free',
  title = `Let's get started`,
  img = Img1,
  alt,
}) => {
  const imageAlt = img ? alt : 'Excited woman planning her wedding';

  return (
    <div>
      <Section>
        <PhotoTitleSection title={title} img={img} imgAlt={imageAlt}>
          <CreateAccountButton
            to={'/start'}
            type={'primary'}
            location="footer"
            label={label}
          />
        </PhotoTitleSection>
      </Section>
      <LinksWrapper>
        <div>
          <div className="copyright">
            &copy; {new Date().getFullYear()} Say I do Wedding Planning Pty Ltd.
          </div>
          <ul>
            <li>
              <a href={'/privacy'}>Privacy Policy</a>
            </li>
            <li>
              <a href={'/terms-of-service'}>Terms of Service</a>
            </li>
            <li>
              <a href={'https://help.sayi.do/#contact'}>Contact Us</a>
            </li>
            {/* <li>
              <a
                href={
                  'https://docs.google.com/forms/d/e/1FAIpQLScAJ6eIWDXYTosDa9-_tnjmTC459Eue7apdHlmnn37pr_7Zxw/viewform'
                }
              >
                Feedback
              </a>
            </li> */}
            <li>
              <a href={'https://forms.gle/x898Bx2jK7CzWCe5A'}>
                Complaints and Compliments
              </a>
            </li>
            <li>
              <a href={'https://sayido.link/affiliate'}>Partnership Program</a>
            </li>
          </ul>
        </div>
        <div>
          <h4>Features</h4>
          <ul>
            <li>
              <a href={'/wedding-websites'}>Wedding Website</a>
            </li>
            <li>
              <a href={'/wedding-checklist'}>Custom Wedding Checklist</a>
            </li>
            <li>
              <a href={'/online-wedding-invitations'}>Online Wedding Invitations</a>
            </li>
            <li>
              <a href={'/online-rsvp'}>RSVP Management</a>
            </li>
            <li>
              <a href={'/wedding-guest-list'}>Wedding Guest List</a>
            </li>
            <li>
              <a href={'/pricing'}>Pricing</a>
            </li>
            {/* <li>
              <a
                href="https://store.sayi.do/collections/invitations"
                target="_blank"
                rel="noreferrer"
              >
                Matching Printed Invitations
              </a>
            </li> */}
          </ul>
        </div>
        {/* <div>
          <h4>Printed Wedding Stationery</h4>
          <ul>
            <li>
              <a
                href="https://store.sayi.do/collections/invitations"
                target="_blank"
                rel="noreferrer"
              >
                Wedding Invitations
              </a>
            </li>
            <li>
              <a
                href="https://store.sayi.do/collections/save-the-date"
                target="_blank"
                rel="noreferrer"
              >
                Save the Dates
              </a>
            </li>
            <li>
              <a
                href="https://store.sayi.do/products/eucalyptus-wedding-invitations"
                target="_blank"
                rel="noreferrer"
              >
                Eucalyptus Wedding Stationery
              </a>
            </li>
            <li>
              <a
                href="https://store.sayi.do/collections/green-foliage"
                target="_blank"
                rel="noreferrer"
              >
                Green Foliage Wedding Stationery
              </a>
            </li>
            <li>
              <a
                href="https://store.sayi.do/collections/precious-neutral"
                target="_blank"
                rel="noreferrer"
              >
                Precious Neutral Wedding Stationery
              </a>
            </li>
            <li>
              <a
                href="https://store.sayi.do/collections/floral-plum"
                target="_blank"
                rel="noreferrer"
              >
                Floral Plum Wedding Stationery
              </a>
            </li>
          </ul>
        </div> */}
        <div>
          <h4>Follow Us</h4>
          <ul>
            <li>
              <a
                href="https://www.instagram.com/sayi_do/"
                target="_blank"
                rel="noreferrer"
              >
                Instagram
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/sayido.au"
                target="_blank"
                rel="noreferrer"
              >
                Facebook
              </a>
            </li>
            <li>
              <a href="/articles">Articles</a>
            </li>
            {/* <li>
              <a
                href="https://www.pinterest.com.au/sayi_do"
                target="_blank"
                rel="noreferrer"
              >
                Pinterest
              </a>
            </li> */}
            {/* <li>
              <a
                href="https://www.sayi.do/leave?url=https://trustpilot.com/review/sayi.do"
                target="_blank"
                rel="noreferrer"
              >
                Reviews
              </a>
            </li> */}
          </ul>
        </div>
        {/* <div>
          <h4>Wedding Suppliers</h4>
          <ul>
            <li>
              <a href="/wedding-celebrants/vic/all">Celebrants in Melbourne</a>
            </li>
            <li>
              <a href="/wedding-celebrants/nsw/all">Celebrants in Sydney</a>
            </li>
            <li>
              <a href="/wedding-celebrants/qld/all">Celebrants in Brisbane</a>
            </li>
            <li>
              <a href="/wedding-photographers/vic/all">
                Photographers in Melbourne
              </a>
            </li>
            <li>
              <a href="/wedding-photographers/nsw/all">
                Photographers in Sydney
              </a>
            </li>
            <li>
              <a href="/wedding-photographers/qld/all">
                Photographers in Brisbane
              </a>
            </li>
          </ul>
        </div> */}
        {/* <div>
          <h4>For Business</h4>
          <ul>
            <li>
              <a href="/business/login">Login</a>
            </li>
          </ul>
        </div> */}
      </LinksWrapper>
    </div>
  );
};

export default Footer;
